(() => {
  const selector = '[data-swatch-item][role="button"]';

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const swatch = event.target.closest(selector);
    if (!swatch) return;
    event.preventDefault();
    swatch.click();
  });

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest(selector);
    if (!swatch) return;
    window.setTimeout(() => {
      const option = swatch.closest('[data-swatch-option]');
      if (!option) return;
      option.querySelectorAll(selector).forEach((item) => {
        item.setAttribute('aria-pressed', item.classList.contains('is--selected') ? 'true' : 'false');
      });
    }, 0);
  });
})();
